import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../../store/api/rx-factory'
import * as Enpoints from '../../../../../store/api/endpoints'
import * as COMMON from '../../../../../store/commomFunction'
import moment from 'moment'

export const actions = {
	[Const.RUN_EDIT_PROFILE]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_EDIT_PROFILE,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_EDIT_PROFILE_PIC]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_EDIT_PROFILE_PIC,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TASK_ACTION_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_TASK_ACTION_LIST,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TASK_ACTION_LIST, result.res_data)
			}else{
				commit(Const.SET_TASK_ACTION_LIST, [])
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_REGISTER_DISEASE_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_REGISTER_DISEASE_LIST,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_REGISTER_DISEASE_LIST, result.res_data)
			}else{
				commit(Const.SET_REGISTER_DISEASE_LIST, [])
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_MEDICINE_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_MEDICINE_LIST,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_MEDICINE_LIST, result.res_data)
			}else{
				commit(Const.SET_REGISTER_DISEASE_LIST, {})
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	//===============================prescription=======================================================
  	[Const.RUN_GET_PATIENT_PRESCRIPTION_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_PATIENT_PRESCRIPTION_LIST,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					let data = [], particularArr  = [],finData = [],json = {},arr = [],finalarr = [];
					for(const key in result.res_data){
						particularArr.unshift(result.res_data[key])
					}
					// if(particularArr.length > 0){
					// 	finData = data.concat(particularArr)
					// }
					particularArr.forEach(val =>{
						val['Prescription']['medicine'] = val['Prescription']['prescription']
						val['PrescriptionOther'] = val['PrescriptionOther'].concat(val['Prescription'])
						delete val['Prescription']
						arr.push(val['PrescriptionOther'])
					})
					arr.forEach(val =>{
						val.forEach(item =>{
							finalarr.push(item)
						})
					})
					if(finalarr.length > 0){
						json['records'] = finalarr
						json['totalRecords'] = finalarr.length
					}else{
						json['records'] = []
						json['totalRecords'] = 0
					}
					commit(Const.SET_PATIENT_PRESCRIPTION_LIST, json)
				}else{
					commit(Const.SET_PATIENT_PRESCRIPTION_LIST,{'records' : [] , 'totalRecords' : 0})
				}
			}else{
				commit(Const.SET_PATIENT_PRESCRIPTION_LIST,{'records' : [] , 'totalRecords' : 0})
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_PATIENT_PRESCRIPTION_DETAIL]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_PATIENT_PRESCRIPTION_DETAIL,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_PATIENT_PRESCRIPTION_DETAIL, result.res_data)
			}else{
				commit(Const.SET_PATIENT_PRESCRIPTION_DETAIL, [])
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_PATIENT_ADDEDIT_PRESCRIPTION]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_PATIENT_ADDEDIT_PRESCRIPTION,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$router.push('/prescription')
				COMMON._messageDisplayFunction(credentials.localParams.parameter,'Save prescription data successfully','success')
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	//===============================test-reports=======================================================
  	[Const.RUN_GET_PATIENT_TEST_REPORT_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_PATIENT_TEST_REPORT_LIST,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					commit(Const.SET_PATIENT_TEST_REPORT_LIST, result.res_data)
				}else{
					commit(Const.SET_PATIENT_TEST_REPORT_LIST,{'records' : [] , 'totalRecords' : 0})
				}
			}else{
				commit(Const.SET_PATIENT_TEST_REPORT_LIST,{'records' : [] , 'totalRecords' : 0})
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_PATIENT_TEST_REPORT_DETAIL]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_PATIENT_TEST_REPORT_DETAIL,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length > 0){
					if(result.res_data[0].hasOwnProperty('cleanData')){
						if(result.res_data[0].hasOwnProperty('dataAddedByadmin')){
							for(var key in result.res_data[0].dataAddedByadmin){
								credentials.localParams.parameter.dynamicVar[key] = key
							}
							commit(Const.SET_PATIENT_TEST_REPORT_DETAIL, result.res_data[0])
						}else{
							let responsedata = {};
							responsedata = result.res_data[0]
							responsedata['dataAddedByadmin'] = {}
							for(var key in result.res_data[0].cleanData){
								credentials.localParams.parameter.dynamicVar[key] = key
								credentials.localParams.parameter.commentdata[key] = '-'
							}
							commit(Const.SET_PATIENT_TEST_REPORT_DETAIL,responsedata)
							credentials.localParams.parameter.reportdata = credentials.localParams.parameter.formatEditdata(responsedata.cleanData,responsedata.Source)
						}
					}
					else{
						commit(Const.SET_PATIENT_TEST_REPORT_DETAIL,{})
					}
				}
			}else{
				commit(Const.SET_PATIENT_TEST_REPORT_DETAIL, {})
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_UPLOAD_PATIENT_TEST_REPORT]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_UPLOAD_PATIENT_TEST_REPORT,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				COMMON._messageDisplayFunction(credentials.localParams.parameter,'upload test report successfully','success')
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.$router.push('/test-report')
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_EDIT_PATIENT_TEST_REPORT]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_EDIT_PATIENT_TEST_REPORT,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.listing()
				COMMON._messageDisplayFunction(credentials.localParams.parameter,'edit test report successfully','success')
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	//===============================appointment=======================================================
  	[Const.RUN_GET_APPOINTMENT_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_APPOINTMENT_LIST,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length  > 0){
					let records = result.res_data //.sort((a,b)=>  Date.parse(b.appointment_date) - Date.parse(a.appointment_date))
					let totalRecord = 0
					if(records[0] && records[0].totalRecords){
						totalRecord = records[0].totalRecords
					}
					commit(Const.SET_APPOINTMENT_LIST, {'records' : records, 'totalRecords' : totalRecord})
				}else{
					commit(Const.SET_APPOINTMENT_LIST, {'records': {},'totalRecords' : 0})
				}
			}else{
				commit(Const.SET_APPOINTMENT_LIST, {'records': {},'totalRecords' : 0})
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_APPOINTMENT_DETAIL]({commit, state,getters,dispatch}, credentials){
		COMMON._executeApi(Enpoints.EP_GET_APPOINTMENT_DETAIL,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_APPOINTMENT_DETAIL, result.res_data[0] || {})
			}else{
				commit(Const.SET_APPOINTMENT_DETAIL, {})
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_APPOINTMENT_INFO]({commit, state,getters,dispatch}, credentials){
		COMMON._executeApi(Enpoints.EP_GET_APPOINTMENT_INFO,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					if(result.res_data.prescription && result.res_data.prescription.length){
						if(result.res_data.prescription_others && Array.isArray(result.res_data.prescription_others)){
							result.res_data.prescription_others = result.res_data.prescription_others.concat(result.res_data.prescription)
						}else{
							result.res_data.prescription_others = result.res_data.prescription
						}
					} 
					commit(Const.SET_APPOINTMENT_INFO, result.res_data)
				}else{
					commit(Const.SET_APPOINTMENT_INFO, {})
				}
			}else{
				commit(Const.SET_APPOINTMENT_INFO, {})
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_ADD_APPOINTMENT]({commit, state,getters,dispatch}, credentials){
		COMMON._executeApi(Enpoints.EP_ADD_APPOINTMENT,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				// COMMON._messageDisplayFunction(credentials.localParams.parameter,'Add Appointment Successfully','error')
				credentials.localParams.parameter.step = 3
			}else{
				credentials.localParams.parameter.printError(result.res_data)
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_DOCTOR_DETAI]({commit, state,getters,dispatch}, credentials){
		COMMON._executeApi(Enpoints.EP_GET_DOCTOR_DETAIL,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.doc_data = result.res_data[0] || {}
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_AVAILABLE_SLOTS_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_AVAILABLE_SLOTS_LIST,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length  > 0){
					commit(Const.SET_AVAILABLE_SLOTS_LIST, result.res_data)
				}else{
					commit(Const.SET_AVAILABLE_SLOTS_LIST, [])
				}
			}else{
				commit(Const.SET_AVAILABLE_SLOTS_LIST,[])
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_BUSY_SLOT_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_BUSY_SLOT_LIST,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length  > 0){
					let busy_slot = result.res_data.map(val => val.slot)
					commit(Const.SET_BUSY_SLOT_LIST, busy_slot)
				}else{
					commit(Const.SET_BUSY_SLOT_LIST, [])
				}
			}else{
				commit(Const.SET_BUSY_SLOT_LIST, [])
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_PATIENT_BUSY_SLOT]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_PATIENT_BUSY_SLOT,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let data = []
				if(result.res_data.length > 0){
					data = result.res_data.map(val=> val.appointmentDate)
					let oldData = getters[Const.GET_PATIENT_BUSY_SLOT]
					data = oldData.concat(data)
					commit(Const.SET_PATIENT_BUSY_SLOT, data)
				}
			}else{
				// commit(Const.SET_PATIENT_BUSY_SLOT, [])
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_BOOK_OBT_CALL]({commit, state,getters,dispatch}, credentials){
		COMMON._executeApi(Enpoints.EP_BOOK_OBT_CALL,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.$parent.CheckObtCallStatus()
				//COMMON._messageDisplayFunction(credentials.localParams.parameter,'Book Call Successfully','success')
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_CHECK_OBT_CALL]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_CHECK_OBT_CALL,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CHECK_OBT_CALL, result.res_data)
			}else{
				commit(Const.SET_CHECK_OBT_CALL, {})
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	//===============================notification=======================================================
  	[Const.RUN_GET_NOTIFICATION_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_NOTIFICATION_LIST,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_NOTIFICATION_LIST, result.res_data)
			}else{
				commit(Const.SET_NOTIFICATION_LIST, [])
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	// ===================== update initial data form ==================================
  	[Const.RUN_ADD_FOOD_INTAKE]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_ADD_FOOD_INTAKE, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.from && credentials.localParams.from == 'daily-task'){
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$parent.addData = ''
					credentials.localParams.parameter.$parent.toggleForm()
					COMMON._messageDisplayFunction(credentials.localParams.parameter,'Add Meal Succesfully','success')
				}else{
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$parent.toggleForm()
				}
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_ADD_WEIGHT]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_ADD_WEIGHT, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.from && credentials.localParams.from == 'daily-task'){
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$parent.addData = ''
					credentials.localParams.parameter.$parent.toggleForm()
					COMMON._messageDisplayFunction(credentials.localParams.parameter,'Add Weight Succesfully','success')
				}else{
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$parent.toggleForm()
					let newObj = {
						_id: 'N/A',
						unit: credentials.globalParams.get('unit'),
						weight: credentials.globalParams.get('weight'),
						xValue: (new Date(credentials.globalParams.get('weight_time'))).getTime(),
						yValue: parseInt(credentials.globalParams.get('weight')),
					}
					let chartData = getters[Const.GET_CHART_DATA]
					let iniialData = getters[Const.GET_INITIAL_DATA]
					iniialData.weight = newObj
					chartData.weight.push(newObj)
					commit(Const.SET_INITIAL_DATA, iniialData)
					commit(Const.SET_CHART_DATA, chartData)
					credentials.localParams.parameter.$parent.redraw(newObj)
				}
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_ADD_BLOOD_PRESSURE]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_ADD_BLOOD_PRESSURE, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				try {
					if(credentials.localParams.from && credentials.localParams.from == 'daily-task'){
						credentials.localParams.parameter.reset()
						credentials.localParams.parameter.$parent.addData = ''
						credentials.localParams.parameter.$parent.toggleForm()
						COMMON._messageDisplayFunction(credentials.localParams.parameter,'Add BP Succesfully','success')
					}else{
						credentials.localParams.parameter.reset()
						credentials.localParams.parameter.$parent.toggleForm()
						let newObj = {
							_id: 'N/A',
							reading_time: credentials.globalParams.get('reading_time'),
							xValue: (new Date(credentials.globalParams.get('reading_time'))).getTime(),
							highValue: parseInt(credentials.globalParams.get('high')),
							high: credentials.globalParams.get('high'),
							lowValue: parseInt(credentials.globalParams.get('low')),
							low: credentials.globalParams.get('low'),
						}
						let chartData = getters[Const.GET_CHART_DATA]
						let iniialData = getters[Const.GET_INITIAL_DATA]
						iniialData.bp = newObj
						chartData.bp.push(newObj)
						commit(Const.SET_INITIAL_DATA, iniialData)
						commit(Const.SET_CHART_DATA, chartData)
						credentials.localParams.parameter.$parent.redraw(newObj)
					}
				} catch(err) {
					console.log(err)
				}
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_ADD_GLUCOSE_DATA]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_ADD_GLUCOSE_DATA, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.from && credentials.localParams.from == 'daily-task'){
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$parent.addData = ''
					credentials.localParams.parameter.$parent.toggleForm()
					COMMON._messageDisplayFunction(credentials.localParams.parameter,'Add Glucose Succesfully','success')
				}else{
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$parent.toggleForm()
					let newObj = {
						_id: 'N/A',
						reading_time: credentials.globalParams.datetime,
						value: credentials.globalParams.value,
						xValue: (new Date(credentials.globalParams.datetime)).getTime(),
						yValue: parseInt(credentials.globalParams.value),
					}
					console.log('action',newObj.xValue)
					let chartData = getters[Const.GET_CHART_DATA]
					let iniialData = getters[Const.GET_INITIAL_DATA]
					iniialData.glucose = newObj
					chartData.glucose.push(newObj)
					commit(Const.SET_INITIAL_DATA, iniialData)
					commit(Const.SET_CHART_DATA, chartData)
					credentials.localParams.parameter.$parent.redraw(newObj)
				}
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_ADD_EMOTION_DATA]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_ADD_EMOTION_DATA, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length > 0){
					let data = result.res_data[0]
					let iniialData = getters[Const.GET_INITIAL_DATA]
					if(data.type){
						iniialData['mood'] = {
							"_id": data._id,
							"type": data.type,
							"mEmotionTime": data.emotion_time
						}
					}else if(data.info){
						iniialData['energy'] = {
							"_id": data._id,
							"info": data.info,
							"mEmotionTime": data.emotion_time
						}
					}
					commit(Const.SET_INITIAL_DATA, iniialData)
				}
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.$parent.toggleForm()
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_ADD_DIGESTION_DATA]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_ADD_DIGESTION_DATA, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.$parent.toggleForm()
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_ADD_SLEEP_DATA]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_ADD_SLEEP_DATA, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.from && credentials.localParams.from == 'daily-task'){
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$parent.addData = ''
					credentials.localParams.parameter.$parent.toggleForm()
					COMMON._messageDisplayFunction(credentials.localParams.parameter,'Add Sleep Data Succesfully','success')
				}else{
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$parent.toggleForm()
					let newObj = {
						_id: 'N/A',
						dateOfSleep: credentials.globalParams.dateOfSleep,
						totalMinutesAsleep: credentials.globalParams.totalMinutesAsleep,
						xValue: (new Date(credentials.globalParams.dateOfSleep)).getTime(),
						yValue: parseInt(credentials.globalParams.totalMinutesAsleep),
					}
					let chartData = getters[Const.GET_CHART_DATA]
					let iniialData = getters[Const.GET_INITIAL_DATA]
					iniialData.sleep = newObj
					chartData.sleep.push(newObj)
					commit(Const.SET_INITIAL_DATA, iniialData)
					commit(Const.SET_CHART_DATA, chartData)
					credentials.localParams.parameter.$parent.redraw(newObj)
				}
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},


  	//===============================initial data=======================================================
  	[Const.RUN_GET_INITIAL_DATA]({commit, state,getters,dispatch}, credentials){	
		  try {
			COMMON._executeApi(Enpoints.EP_INITIAL_DATA,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
				if(!error){
					let data = result.res_data
					let obj = {
						bp: data.bp.length ? data.bp[0] : {},
						energy: data.energy.length ? data.energy[0] : {},
						glucose: data.gulcoase.length ? data.gulcoase[0] : {},
						food: data.food.length ? data.food[0] : {},
						mood: data.mood.length ? data.mood[0] : {},
						weight: data.weight.length ? data.weight[0] : {},
						heart: data.fitbit && data.fitbit.heart.length ? data.fitbit.heart[0] : {},
						sleep: data.fitbit && data.fitbit.sleep.length ? data.fitbit.sleep[0] : {},
						steps: data.fitbit && data.fitbit.steps.length ? data.fitbit.steps[0] : {},				
					}
					commit(Const.SET_INITIAL_DATA, obj)
				}else{
					COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				}
			}) 	
		  } catch(err) {
			console.log(err)
		  }
  	},

	//===============================chart data=======================================================
  	[Const.RUN_GET_CHART_DATA]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_CHART_DATA,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let obj = {
					bp: [],
					sleep: [],
					heart: [],
					glucose: [],
					weight: [],
					steps: [],
				}
				for(let key in result.res_data) {
					if(key == 'gulcoase') {
						if(result.res_data[key].length) {
							result.res_data[key].map(i => {
								i.xValue = (new Date(i.datetime)).getTime()
								i.yValue = parseInt(i.value)
							})
							obj['glucose'] = result.res_data[key]
						}
					} else if(key == 'bp') {
						if(result.res_data[key].length) {
							result.res_data[key].map(i => {
								i.xValue = (new Date(i.readingDate)).getTime()
								i.highValue = parseInt(i.high)
								i.lowValue = parseInt(i.low)
							})
							obj[key] = result.res_data[key]
						}

					} else if(key == 'heart') {
						if(result.res_data[key].length) {
							result.res_data[key].map(i => {
								i.xValue = (new Date(i.intervalDate)).getTime()
								i.yValue = parseInt(i.heartRate)
							})
							obj[key] = result.res_data[key]
						}

					} else if(key == 'sleep') {
						if(result.res_data[key].length) {
							result.res_data[key].map(i => {
								i.xValue = (new Date(i.dateOfSleep)).getTime()
								i.yValue = parseInt(i.totalMinutesAsleep)
							})
							obj[key] = result.res_data[key]
						}

					} else if(key == 'steps') {
						if(result.res_data[key].length) {
							result.res_data[key].map(i => {
								i.xValue = (new Date(i.startTime)).getTime()
								i.yValue = parseInt(i.steps)
							})
							obj[key] = result.res_data[key]
						}

					} else if(key == 'weight') {
						if(result.res_data[key].length) {
							result.res_data[key].map(i => {
								i.xValue = (new Date(i.weightDate)).getTime()
								i.yValue = parseInt(i.weight)
							})
							obj[key] = result.res_data[key]
						}
					}
				}
				commit(Const.SET_CHART_DATA, obj)
				if(credentials.globalParams.innerPage) {
					credentials.localParams.parameter.createChart()
				}
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
}






// WEBPACK FOOTER //
// ./src/plugins/Gini/provider/candle-history/store-addons/actions.js